import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const ConfirmationPerson = () => {
  const location = useLocation();
  const { payload } = location.state || {};

  const MaskGroupImage = "/documents/d/guest/Mask-group_1";
  const AssetImage1_500w = "/documents/d/guest/44471622448-1-p-500";
  const AssetImage2_500w = "/documents/d/guest/image-p-500";
  const GroupImage = "/documents/d/guest/Group";
  
  return (
    <>
      <section className="hero relative">
        <div className="banner_bg is-ajuste">
          <img
            loading="lazy"
            src={MaskGroupImage}
            alt=""
            className="banner_person-full is-medium movil"
          />
          <img
            sizes="(max-width: 479px) 100vw, (max-width: 767px) 320px, (max-width: 991px) 28vw, 572.25px"
            srcSet={`${AssetImage1_500w} 500w, /documents/d/guest/44471622448-1 585w`}
            alt=""
            src="/documents/d/guest/44471622448-1"
            loading="lazy"
            className="banner_person-full is-medium desp"
          />
          <img
            sizes="(max-width: 991px) 100vw, 613.921875px"
            srcSet={`${AssetImage2_500w} 500w, /documents/d/guest/image 785w`}
            alt=""
            src="/documents/d/guest/image"
            loading="lazy"
            className="banner_person-full medium is-ajuste desp"
          />
        </div>
      </section>
      <section className="info-h">
        <div className="padding-global">
          <div className="padding-section-large">
            <div className="container-medium">
              <div className="info_wrp">
                <img src={GroupImage} loading="lazy" alt="" />
                <div className="title-component is-center">
                  <h1 className="heading-style-h2">
                    ¿Estás seguro de actualizar tu información?
                  </h1>
                  <div className="line-title"></div>
                </div>
                <Link
                  to={'/mi-perfil/actualiza-tus-datos'}
                  state={{ payload: payload }}
                  className="button is-large w-button"
                >
                  Sí, estoy seguro
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConfirmationPerson;
